import { gql } from '@apollo/client';

export const CREATE_USER_RECKONING = gql`
  mutation CreateUserReckoning($input: UserReckoningCreateInput!) {
    createUserReckoning(input: $input) {
      _id
    }
  }
`;